import { render, staticRenderFns } from "./medsos_sentiment_post.vue?vue&type=template&id=16acffe4&scoped=true"
import script from "./medsos_sentiment_post.vue?vue&type=script&lang=js"
export * from "./medsos_sentiment_post.vue?vue&type=script&lang=js"
import style0 from "./medsos_sentiment_post.vue?vue&type=style&index=0&id=16acffe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16acffe4",
  null
  
)

export default component.exports